import { render, staticRenderFns } from "./ModuleGraph.vue?vue&type=template&id=648889b9"
import script from "./ModuleGraph.vue?vue&type=script&lang=js"
export * from "./ModuleGraph.vue?vue&type=script&lang=js"
import style0 from "./ModuleGraph.vue?vue&type=style&index=0&id=648889b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports